import type React from 'react'

import { useServiceType } from '@hooks'

// A record rather than named props: adding a service type then fails to compile at every call site
// instead of silently falling through to one of the existing brands.
type ServiceTypeSwitchProps = Record<ServiceType, React.ReactNode>

/**
 * Renders the slot matching the active company's service type.
 *
 * @example <ServiceTypeSwitch autotax={<AutotaxLogo />} quickkeret={<KafLogo />} />
 */
export function ServiceTypeSwitch(slots: ServiceTypeSwitchProps) {
  const serviceType = useServiceType()

  return <>{slots[serviceType]}</>
}
